export default "__VITE_ASSET__fa0b2bf5__"